import { Component } from '@angular/core';
import { UserMenuContentComponent } from './user-menu-content.component';
import { UserMenuAbstract } from './user-menu.abstract';

@Component({
  selector: 'app-user-menu-drawer',
  imports: [UserMenuContentComponent],
  template: `
    <div class="user-menu-drawer">
      <header class="user-menu-header">
        <h2 class="title-regular">Perfil</h2>
        <button
          type="button"
          class="user-menu-header__action"
          aria-label="Fechar menu"
          (click)="closeMenu()"
        >
          <i class="bi bi-x-lg" aria-hidden="true"></i>
        </button>
      </header>
      <app-user-menu-content></app-user-menu-content>
    </div>
  `,
  styles: [
    `
      .user-menu-drawer {
        padding: 1.5rem;
        height: 100%;
        width: 40vw;
        background-color: #fff;
      }

      .user-menu-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.5rem;
      }

      .user-menu-header__action {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        border: none;
        background: transparent;
        cursor: pointer;
        color: var(--text-primary);
        font-size: 1.25rem;
      }
    `,
  ],
})
export class UserMenuDrawerComponent extends UserMenuAbstract {}
